module.exports = __webpack_public_path__ + "sk-rv-complete-mockup.yUCqHuez.png";